import type { FaireProductEntity } from "../../entity_types/product";

export const p_srkm2kqh2f: FaireProductEntity = {
  token: "p_srkm2kqh2f",
  type: "product",
  name: "Pink Tulip Thank You Boxed Card Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/cd0eb64273360643e22620c41ec4cdefb7fcec27a7e6a69e80bd6224065d3b0b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/932f348164a9c1f9ad7f2e88b070e0b6c954e1b56cc143ac0bfbead349491efb.jpeg",
    "https://cdn.faire.com/fastly/84e2d259150e03d0f3291412274acd53de704d476e44080d48469dab2ef20a7b.jpeg",
  ],
  priceDollars: 11,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:50.341Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
